<template>
  <div class="personManage">
    <div class="search">
      <span class="title">人员管理</span>
      <div class="flex">
        <div class="condition">
          <span style="flex: 1">所属区域：</span>
          <el-select v-model="searchForm.areaId" filterable placeholder="请选择" @change="getList">
            <el-option v-for="(item, index) in areaList" :key="item.index" :label="item.areaName" :value="item.areaId"></el-option>
          </el-select>
        </div>
        <div class="condition">
          <span style="flex: 1">用户：</span>
          <el-input placeholder="请输入用户" v-model="searchForm.userName" @change="getList" style="width: 80%"></el-input>
        </div>
        <el-button type="success" @click="openDialog">新增</el-button>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" height="700px" v-loading="loading" element-loading-text="数据加载中..." align="center" :header-cell-style="{ background: '#f4f7fe' }">
        <el-table-column prop="userName" label="用户"></el-table-column>
        <el-table-column prop="areaNmae" label="所属区域"></el-table-column>
        <el-table-column prop="level" label="级别">
          <template slot-scope="scope">
            <span>{{ scope.row.level == 1 ? '执行人' : '管理员' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="单位"></el-table-column>
        <el-table-column prop="creationTime" label="创建时间"></el-table-column>
        <el-table-column label="操作" align="right">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)" type="success" size="small">编辑</el-button>
            <el-button @click="getUserDetail(scope.row.id)" type="success" size="small">详情</el-button>
            <el-button @click="deleteRowData(scope.row)" type="success" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50]"
        layout="sizes, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 详情对话框 -->
    <el-drawer :title="detailForm.userName" :visible.sync="detailModal" size="20%" append-to-body>
      <el-form :model="detailForm" ref="detailForm" style="padding: 10px">
        <el-form-item label="用户名" laber-width="120px">
          <span>{{ detailForm.userName }}</span>
        </el-form-item>
        <el-form-item label="所属区域" laber-width="120px">
          <span>{{ detailForm.areaName }}</span>
        </el-form-item>
        <el-form-item label="用户级别" laber-width="120px">
          <span>{{ detailForm.level == 1 ? '执行人' : '管理员' }}</span>
        </el-form-item>
        <el-form-item label="职位" laber-width="120px">
          <span>{{ detailForm.post }}</span>
        </el-form-item>
        <el-form-item label="单位" laber-width="120px">
          <span>{{ detailForm.unit }}</span>
        </el-form-item>
        <el-form-item label="责任区" laber-width="120px" v-if="detailForm.jurisdictionName != '' && detailForm.level == 1">
          <span>{{ detailForm.jurisdictionName }}</span>
        </el-form-item>
      </el-form>
    </el-drawer>
    <!--新增/编辑用户 -->
    <el-dialog :title="dialogType == 'add' ? '新增用户' : '编辑用户'" :visible="dialogVisible" width="450px" :before-close="handleClose">
      <el-form class="margin-top-sm" label-width="100px">
        <el-form-item label="所属区域">
          <el-select v-model="ruleForm.areaId" filterable style="width: 100%" placeholder="请选择" @change="getAreaList2">
            <el-option v-for="(item, index) in areaList" :key="item.index" :label="item.areaName" :value="item.areaId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名">
          <el-cascader
            ref="cascaderAddr"
            v-model="ruleForm.userCode"
            :options="peopeleData"
            placeholder="请选择用户"
            :show-all-levels="false"
            style="width: 100%"
            v-if="dialogType == 'add'"
            filterable="true"
          ></el-cascader>
          <div v-else>{{ ruleForm.userName }}</div>
        </el-form-item>
        <el-form-item label="职务">
          <el-input placeholder="请输入职务" v-model="ruleForm.post"></el-input>
        </el-form-item>
        <el-form-item label="单位">
          <el-input placeholder="请输入单位" v-model="ruleForm.unit"></el-input>
        </el-form-item>
        <el-form-item label="级别">
          <el-radio v-model="ruleForm.level" :label="1">执行人</el-radio>
          <el-radio v-model="ruleForm.level" :label="2">管理员</el-radio>
        </el-form-item>
        <el-form-item label="责任区" v-if="isShowJurisdiction == true && ruleForm.level == 1">
          <el-select v-model="ruleForm.jurisdictionId" multiple placeholder="请选择">
            <el-option v-for="item in areaList2" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="success" @click="addConfirm" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { GetDepartmentUser } from '@/api/staff.js'
  import { GetAreaBox, AddVectorTaskUser, GetVectorTaskUserLis, GetVectorTaskUserDetails, UpdateVectorTaskUser, DeleteVectorTaskUser } from '@/api/vectorTask.js'
  import { GetAreaListByPId } from '@/api/area.js'
  export default {
    name: 'personManage',
    data() {
      return {
        searchForm: {
          userName: '',
          areaId: -1,
          aLevel: 0,
        },
        ruleForm: {
          userCode: '',
          areaId: null,
          unit: '',
          level: 1,
          post: '',
          jurisdictionId: [],
        },
        isShowJurisdiction: false, //是否显示责任区
        power: -1, //角色权限
        detailModal: false, //详情
        loading: false, // 数据是否处于加载状态
        tableData: [], // 表格数据
        detailForm: {}, //详情数据
        total: 0, // 数据总数
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前查询数据个数
        dialogVisible: false, // 对话框是否显示
        dialogType: 'add', //弹窗类型
        areaList: [],
        areaList2: [],
        peopeleData: [],
        type: 1, //1:查询，2：新增或编辑
        editID: null,
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      },
    },
    mounted() {
      this.getAreaSelectList()
      this.getList()
    },
    methods: {
      //获取人员管理区域乡镇名称下拉框
      async getAreaSelectList() {
        await GetAreaBox(this.type).then((res) => {
          if (res.data.state == 1) {
            this.areaList = res.data.data
          }
        })
      },
      //获取右江区下面的所有乡镇
      getAreaList2() {
        if (this.ruleForm.areaId == null) return

        if (this.areaList.some((res) => res.areaId == this.ruleForm.areaId && res.aLevel == 2)) {
          this.isShowJurisdiction = false
        } else {
          this.isShowJurisdiction = true
        }
        GetAreaListByPId(this.ruleForm.areaId).then((res) => {
          if (res.data.state == 1) {
            this.areaList2 = res.data.data
          }
        })
      },
      // 获取用户角色和部门
      getDepartmentUser() {
        GetDepartmentUser().then((res) => {
          this.peopeleData = res.data.data
        })
      },
      // 获取任务人员详情
      async getUserDetail(id) {
        await GetVectorTaskUserDetails(id).then((res) => {
          if (res.data.state == 1) {
            if (this.dialogType == 'edit') {
              this.ruleForm.post = res.data.data.post
              this.ruleForm.areaId = res.data.data.areaId
              this.ruleForm.unit = res.data.data.unit
              this.ruleForm.userName = res.data.data.userName
              this.ruleForm.level = res.data.data.level
              this.ruleForm.jurisdictionId = res.data.data.jurisdictionId
            } else {
              this.detailForm = res.data.data
              this.detailModal = true
            }
          }
        })
      },
      //关闭新增
      handleClose() {
        this.ruleForm = {
          userCode: '',
          areaId: null,
          level: 1,
          post: '',
          unit: '',
          jurisdictionId: [],
        }
        this.areaList = []
        this.areaList2 = []
        this.peopeleData = []
        this.type = 1
        this.getAreaSelectList()
        this.dialogType = 'add'
        this.dialogVisible = false
      },
      // 添加、编辑确认
      addConfirm() {
        const that = this
        if (that.ruleForm.areaId == null) {
          return that.$message.error('请选择区域')
        }
        if (that.ruleForm.userCode == '' && that.dialogType == 'add') {
          return that.$message.error('请选择林长')
        }
        if (that.ruleForm.post == '') {
          return that.$message.error('请填写林长职务')
        }
        if (that.ruleForm.unit == '') {
          return that.$message.error('请填写单位')
        }
        if (that.isShowJurisdiction && that.ruleForm.level == 1 && that.ruleForm.jurisdictionId.length == 0) {
          return that.$message.error('请选择乡镇')
        }
        that.loading = true
        let params = {
          userCode: that.ruleForm.userCode[that.ruleForm.userCode.length - 1],
          post: that.ruleForm.post,
          areaId: that.ruleForm.areaId,
          unit: that.ruleForm.unit,
          level: that.ruleForm.level,
          jurisdictionId: that.isShowJurisdiction && that.ruleForm.level == 1 ? that.ruleForm.jurisdictionId : [],
        }
        if (that.dialogType == 'add') {
          AddVectorTaskUser(params).then((res) => {
            if (res.data.state == 1) {
              that.$message.success('添加成功')
              that.loading = false
              that.handleClose()
              that.getList()
            } else {
              that.$message.error(res.data.Msg)
              that.loading = false
            }
          })
        } else {
          params.id = that.editID
          UpdateVectorTaskUser(params).then((res) => {
            if (res.data.state == 1) {
              that.$message.success('编辑成功')
              that.loading = false
              that.handleClose()
              that.getList()
            } else {
              that.loading = false
              that.$message.error(res.data.Msg)
            }
          })
        }
      },
      // 分页查询
      handleSizeChange(e) {
        this.pageSize = e
        this.getList()
      },
      handleCurrentChange(e) {
        this.currentPage = e
        this.getList()
      },
      /*获取所有数据列表 */
      async getList() {
        this.loading = true
        try {
          let params = {
            pageNumber: this.currentPage,
            pageSize: this.pageSize,
            userName: this.searchForm.userName,
            areaId: this.searchForm.areaId,
          }
          let { data } = await GetVectorTaskUserLis(params)
          if (data.state === 1) {
            this.tableData = data.data.lis
            this.total = data.data.count
            this.loading = false
          } else {
            this.loading = false
            this.$message.error(data.message)
          }
        } catch (err) {
          this.loading = false
          this.$message.error('获取列表失败,请稍后重试!')
        }
      },
      // 编辑
      async edit(row) {
        this.dialogType = 'edit'
        this.editID = row.id
        await this.getUserDetail(row.id)
        this.type = 2
        await this.getAreaSelectList()
        this.getAreaList2()
        this.dialogVisible = true
      },
      /* 通过ID删除单行数据 */
      deleteRowData(row) {
        this.$confirm('确定删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            DeleteVectorTaskUser(row.id).then((res) => {
              if (res.data.state == 1) {
                this.$message.success('操作成功')
                this.getList()
              } else {
                this.$message.erroe(res.data.Msg)
              }
            })
          })
          .catch(() => {})
      },
      // 打开添加弹窗
      openDialog() {
        this.dialogType = 'add'
        this.type = 2
        this.getAreaSelectList()
        this.getDepartmentUser()
        this.isShowJurisdiction = true
        this.dialogVisible = true
      },
    },
  }
</script>
<style lang="less" scoped>
  .personManage {
    height: 100%;
    width: 100%;
    position: relative;

    .search {
      padding: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        font-size: 20px;
        font-weight: bold;
      }
      .condition {
        display: flex;
        align-items: center;
        margin-right: 20px;
      }
    }
    .table {
      padding: 0px 15px;
    }

    .page {
      text-align: center;
    }

    /deep/ .el-dialog__header {
      padding: 10px;
      background-color: #5bacf0;
    }

    /deep/ .el-dialog__title {
      color: #fff;
    }

    /deep/ .el-dialog__body {
      padding: 15px;
    }

    /deep/ .el-dialog__footer {
      padding: 0px 10px 10px 10px;
    }

    .right_drawer {
      position: absolute;
      right: 0px;
      top: -15px;
      height: 100%;
      border: 1px solid #ccc;
      background-color: #fff;
      transition: all 0.3s ease;
      padding-top: 40px;
      z-index: 20;
      width: 0px;

      .close_icon {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        color: red;
        font-size: 22px;
      }
    }
  }

  /deep/.el-drawer {
    top: 60px !important;
  }

  .avatar {
    width: 100px;
    height: 100px;
    margin-right: 10px;
  }
</style>
